export default __webpack_public_path__ + "static/media/vire3.26301ca0.jpg";